import { Component } from '@angular/core';
import { SpinnerService } from './services/spinner.service';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NotifierModule } from "angular-notifier";
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './components/shared/spinner/spinner.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
      standalone: true,
  imports: [
    RouterOutlet,
    NotifierModule,
    CommonModule,
    SpinnerComponent
    
]
})
export class AppComponent {
  title = 'STDAG';
  isLoading = false;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit() {
    this.spinnerService.isLoading$.subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
  }

  onActivate(event) {
    window.scroll(0, 0);
    // or window.scrollTo(0, 0);
    // or document.body.scrollTop = 0;
    // or document.querySelector('body').scrollTo(0,0)
  }
}
